"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Banks_1 = __importDefault(require("./Banks"));
var TransformMiddlewares_1 = __importDefault(require("./TransformMiddlewares"));
var ParserJSON = (function () {
    function ParserJSON() {
    }
    ParserJSON.prototype.genComponentJSON = function (json) {
        var _a, _b;
        var reservedList = Banks_1.default.getReservedComponentIds();
        if (!json.from && !reservedList.includes(json.from)) {
            throw new Error('Not a valid component, unknown source From');
        }
        if (reservedList.includes(json.from))
            return __assign(__assign({}, json), { props: TransformMiddlewares_1.default.transformProps((_a = json.props) !== null && _a !== void 0 ? _a : {}), style: TransformMiddlewares_1.default.transformStyle((_b = json.style) !== null && _b !== void 0 ? _b : {}) });
        var sourceComponent = Banks_1.default.banks[json.from];
        var mergedComponent = __assign(__assign(__assign({}, sourceComponent), json), { id: json.id, from: sourceComponent.from, style: TransformMiddlewares_1.default.transformStyle(__assign(__assign({}, sourceComponent.style), json.style)), onHoverStyle: TransformMiddlewares_1.default.transformStyle(__assign(__assign({}, sourceComponent.onHoverStyle), json.onHoverStyle)), onResponsiveStyle: TransformMiddlewares_1.default.transformStyle(__assign(__assign({}, sourceComponent.onResponsiveStyle), json.onResponsiveStyle)), props: TransformMiddlewares_1.default.transformStyle(TransformMiddlewares_1.default.transformProps(__assign(__assign({}, sourceComponent.props), json.props))) });
        if (reservedList.includes(mergedComponent.from))
            return mergedComponent;
        else
            return this.genComponentJSON(mergedComponent);
    };
    return ParserJSON;
}());
exports.default = new ParserJSON();
//# sourceMappingURL=ParserJSON.js.map